<script>
export default {
  name: "SearchField",
  props: {
    modelValue: [String, Number],
    label: String,
    mask: Object,
    suffix: String,
    name: String,
    appendIcon: String,
    type: {
      type: String,
      default: "text",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    error: Boolean,
    hideDetails: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue", "search"],
  data() {
    return {
      model: null,
      hasValueChanged: false,
    };
  },
  watch: {
    model() {
      this.$emit("update:modelValue", this.model);
    },
    modelValue(value, prevValue) {
      this.model = this.modelValue;

      this.hasValueChanged = value !== prevValue;
    },
  },
  created() {
    this.model = this.modelValue;
  },
  methods: {
    search() {
      if (this.hasValueChanged) {
        this.$emit("search");
      }

      this.hasValueChanged = false;
    },
    cleared() {
      this.$emit("update:modelValue", null);
      this.search();
    },
  },
};
</script>

<template>
  <v-text-field
    v-model="model"
    v-maska:[mask]
    :append-inner-icon="appendIcon"
    :clearable="clearable"
    :error="error"
    :hide-details="hideDetails"
    :label="label"
    :name="name"
    :rules="rules"
    :suffix="suffix"
    :type="type"
    autocomplete="off"
    color="primary"
    density="compact"
    role="presentation"
    variant="outlined"
    @blur="search"
    @keyup.enter="search"
    @click:clear="cleared"
  />
</template>

<style scoped></style>
